import { render, staticRenderFns } from "./contacts_card.vue?vue&type=template&id=6a2c0f3f&scoped=true&"
import script from "./contacts_card.vue?vue&type=script&lang=js&"
export * from "./contacts_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c0f3f",
  null
  
)

export default component.exports